import React from "react";
import { caseFileActions } from "../../../constants/caseFiles";
import {
    Box,
    Button,
    Typography,
    Dialog,
    DialogTitle,
    DialogActions,
    DialogContent,
    DialogContentText,
    makeStyles,
} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
    diaTitle: {
        flexGrow: 1,
        display: "flex",
        alignItems: "center",
    },
}));

export default function FileDeleteDialog({
    updateTreeData,
    treeData,
    setTreeToSave,
    fileDeleteDialogOpen,
    setFileDeleteDialogOpen,
    fileToRemove,
    caseDocumentTypes,
    precedentsToMarkAsRemoved,
    setPrecedentsToMarkAsRemoved,
    filesToMarkAsRemoved,
    setFilesToMarkAsRemoved,
    newParent,
}) {
    const classes = useStyles();

    const removeNode = () => {
        const updatedTreeData = updateTreeData(treeData, fileToRemove, newParent, caseFileActions.REMOVE);
        if (fileToRemove.type === caseDocumentTypes.PRECEDENT_DOCUMENT) {
            setPrecedentsToMarkAsRemoved([
                ...precedentsToMarkAsRemoved,
                fileToRemove.precedentFileMetadata.precedentIdentifier,
            ]);
        } else {
            setFilesToMarkAsRemoved([
                ...filesToMarkAsRemoved,
                fileToRemove.azureFileMetadata.azureFileReference,
            ]);
        }
        setTreeToSave(updatedTreeData);
    };

    const removeFile = () => {
        removeNode();
        setFileDeleteDialogOpen(false);
    };

    return (
        <Dialog
            open={fileDeleteDialogOpen}
            onClose={() => setFileDeleteDialogOpen(false)}
            fullWidth
        >
            <DialogTitle>
                <Box display="flex" alignItems="center">
                    <Typography
                        variant="h6"
                        component="div"
                        className={classes.diaTitle}
                    >
                        Confirm removal of File
                    </Typography>
                </Box>
            </DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Please confirm that you want to remove this file?
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button
                    color="primary"
                    onClick={() => setFileDeleteDialogOpen(false)}
                >
                    Cancel
                </Button>
                <Button
                    color="primary"
                    variant="contained"
                    onClick={() => removeFile()}
                >
                    Remove File
                </Button>
            </DialogActions>
        </Dialog>
    )
}